// extracted by mini-css-extract-plugin
export var primitiveLabel = "_vl-0";